export * from './forgot-password.view';